<template>
  <!-- 首年梯度加费 -->
  <div>
    <Modal v-model="visible" width="1200px" title="梯度加费" :footer-hide="true" :mask-closable="false" class="my-modal">
      <div class="tools-box right" v-if="!list || list.length == 0">
        <Button type="primary" @click="add">新增费用项</Button>
      </div>
      <Form ref="form" :model="bean" :label-width="90" class="page-form less" v-for="(bean, i) in list" :key="bean.key">
        <FormItem prop="expenseItem" label="费用项名称" :rules="$units.formRule.required('请输入费用项名称')">
          <Input v-model="bean.expenseItem" placeholder="请输入" :disabled="bean.disabled" />
        </FormItem>
        <FormItem class="btn-item">
          <Button type="primary" @click="add">新增费用项</Button>
          <Button type="error" @click="del(list, i, 1)" :disabled="bean.disabled">删除</Button>
        </FormItem>
        <FormItem prop="agreementId" label="关联协议">
          <Select v-model="bean.agreementId" clearable filterable style="width: 350px" @on-change="selectAgreement(bean)" :disabled="bean.disabled">
            <Option v-for="bean in agreementList" :key="bean.id" :value="bean.id">{{ bean.name }} </Option>
          </Select>
          <Button type="text" @click="goAgreement">去维护协议＞</Button>
        </FormItem>
        <FormItem prop="feeComputeType" label="计算因子" :rules="$units.formRule.required('请选择计算因子')">
          <RadioGroup v-model="bean.feeComputeType">
            <Radio label="1" :disabled="bean.disabled">规模保费</Radio>
            <Radio label="2" :disabled="bean.disabled" v-if="topItem.productCategory == 3">上游标保</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="expenseStartTime" :label-width="140" label="费用有效期开始日期" :rules="$units.formRule.required('请选择费用有效期开始日期')">
          <DatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            split-panels
            :value="bean.expenseStartTime"
            @on-change="bean.expenseStartTime = $event"
            placeholder="请选择"
            :disabled="bean.disabled || bean.isSatrt"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem
          prop="expenseEndTime"
          :label-width="140"
          label="费用有效期结束日期"
          :rules="[$units.formRule.required('请选择费用有效期结束日期'), dateRule(bean)]"
        >
          <DatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            split-panels
            :value="bean.expenseEndTime"
            @on-change="bean.expenseEndTime = $event"
            placeholder="请选择"
            :disabled="bean.disabled"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem prop="programIds" label="条件方案" class="full" :rules="$units.formRule.arrRequired('请选择条件方案')">
          <Select v-model="bean.programIds" multiple :disabled="bean.disabled" style="width: 950px" transfer>
            <Option v-for="bean in tableItem.programBaseList" :key="bean.id" :value="bean.id">{{ bean.name }} </Option>
          </Select>
          <Button type="text" @click="$refs.activityGradientExample.open()">配置举例</Button>
        </FormItem>
        <div class="table">
          <div class="tr">
            <div class="td th td1">条件方案</div>
            <div class="table-box td23">
              <div class="tr">
                <div class="td th td2">目标方案</div>
                <div class="td th td3">费用率（%）</div>
              </div>
            </div>
          </div>
          <div class="tr" v-for="(row, ii) in bean.gradientItemList" :key="row.key" :id="'key' + row.key">
            <div class="td td1">
              <Input
                v-model="row.conditionStart"
                placeholder="请输入"
                style="width: 90px"
                class="table-input"
                :class="{ 'red-bor': row.startError }"
                :disabled="bean.disabled"
              />
              <Select v-model="row.conditionStartSymbol" style="width: 60px" transfer :disabled="bean.disabled">
                <Option value="1" label="<"></Option>
                <Option value="2" label="≤"></Option>
              </Select>
              <Select
                v-model="row.conditionType"
                style="width: 120px"
                transfer
                :disabled="bean.disabled"
                @on-change="typeChange(row.conditionType, bean.gradientItemList)"
              >
                <Option :value="1" label="累计规模保费"></Option>
                <Option :value="2" label="累计标准保费" v-if="topItem.productCategory == 3"></Option>
              </Select>
              <Select v-model="row.conditionEndSymbol" style="width: 60px" transfer :disabled="bean.disabled">
                <Option value="1" label="<"></Option>
                <Option value="2" label="≤"></Option>
              </Select>
              <Input
                v-model="row.conditionEnd"
                placeholder="请输入"
                style="width: 90px"
                class="table-input"
                :class="{ 'red-bor': row.endError }"
                :disabled="bean.disabled"
              />
              <Icon type="md-add-circle" color="#236DFF" size="24" @click="addRow(bean.gradientItemList, row.conditionType)" v-if="!bean.disabled" />
              <Icon
                type="md-close-circle"
                color="#F26868"
                size="24"
                v-if="bean.gradientItemList.length != 1 && !bean.disabled"
                @click="del(bean.gradientItemList, ii, 2)"
              />
            </div>
            <div class="table-box td23">
              <div class="tr" v-for="(row2, iii) in row.programCommissionList" :key="row2.key" :id="'key' + row2.key">
                <div class="td td2">
                  <Select v-model="row2.programIds" multiple style="width: 250px" transfer :disabled="bean.disabled" :class="{ 'red-bor': row2.error }">
                    <Option v-for="p in tableItem.programBaseList" :key="p.id" :value="p.id" :disabled="load && disabledOpt(row.programCommissionList, p.id)"
                      >{{ p.name }}
                    </Option>
                  </Select>
                  <Icon type="md-add-circle" color="#236DFF" size="24" @click="addCommission(row.programCommissionList)" v-if="!bean.disabled" />
                  <Icon
                    type="md-close-circle"
                    color="#F26868"
                    size="24"
                    v-if="row.programCommissionList.length != 1 && !bean.disabled"
                    @click="del(row.programCommissionList, iii, 2)"
                  />
                </div>
                <div class="td td3">
                  <Input
                    v-model="row2.commission"
                    placeholder="请输入"
                    class="table-input"
                    @input="inputChange(row2, $event)"
                    :class="{ 'red-bor': row2.commissionError }"
                    :disabled="bean.disabled"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
    <!-- 示例 -->
    <activity-gradient-example ref="activityGradientExample"></activity-gradient-example>
  </div>
</template>
  
<script>
import confirmModal from '@/components/commons/confirmModal';
import activityGradientExample from './activityGradientExample';
import activityGradient from './activityGradient.config.js';
import common from './common.config.js';
export default {
  mixins: [activityGradient, common],
  components: { confirmModal, activityGradientExample },
  props: {
    curSupplier: null
  },
  data() {
    return {
      visible: false,
      loading: false,
      over: true,
      tableItem: {},
      agreementList: [], //协议列表
      topItem: {}
    };
  },
  computed: {},
  created() {},
  methods: {
    async open(e) {
      this.tableItem = e.tableItem;
      this.topItem = e.topItem;
      if (this.topItem.sourceType != 2) {
        return;
      }
      const status = await this.getStatus();
      if (status) {
        this.initData(true);
        this.getAgreementList();
      } else {
        this.openBaseModal();
      }
    },
    // 同步类型
    typeChange(conditionType, list) {
      list.forEach(item => {
        item.conditionType = conditionType;
      });
    },
    // 时间选择规则
    dateRule(bean) {
      return {
        required: true,
        message: '结束时间不可小于开始时间',
        trigger: 'change',
        validator(rule, value) {
          if (bean.expenseStartTime && bean.expenseEndTime && bean.expenseStartTime > bean.expenseEndTime) {
            return false;
          }
          return true;
        }
      };
    },
    // 跳转协议页面
    goAgreement() {
      this.$router.push('/offline/agreementManage/supplierAgreement');
    },
    // 获取协议列表
    getAgreementList() {
      this.$http({
        url: '/buz/covenant/read/list',
        type: 'POST',
        data: {
          insuranceSupplierId: this.curSupplier.companyId,
          covenantSource: 1,
          covenantType: this.curSupplier.companyType,
          productCode: this.topItem.productCode,
          pageNum: 1,
          pageSize: 999
        }
      }).then(res => {
        this.agreementList = res.data;
      });
    },
    // 选择协议
    selectAgreement(bean) {
      const data = this.agreementList.find(item => item.id == bean.agreementId);
      bean.expenseStartTime = data.startTime;
      bean.expenseEndTime = data.endTime;
    },
    // 新增费用项
    add() {
      const key = Date.now();
      this.list.unshift({
        productCode: this.topItem.productCode,
        isMain: this.tableItem.isMain,
        gradeCode: this.tableItem.gradeCode,
        key: key,
        expenseStartTime: '',
        expenseEndTime: '',
        feeComputeType: '1',
        gradientItemList: [
          {
            key: 'a' + key,
            conditionStart: '',
            conditionStartSymbol: '1',
            conditionType: 1,
            conditionEndSymbol: '1',
            conditionEnd: '',
            programCommissionList: [{ key: 'b' + key, programIds: [], commission: '' }]
          }
        ]
      });
    },
    // 新增行
    addRow(list, conditionType) {
      const key = Date.now();
      list.push({
        key: 'a' + key,
        conditionStart: '',
        conditionStartSymbol: '1',
        conditionType: conditionType,
        conditionEndSymbol: '1',
        conditionEnd: '',
        programCommissionList: [{ key: 'b' + key, programIds: [], commission: '' }]
      });
      this.$nextTick(() => {
        document.getElementById('keya' + key).scrollIntoView();
      });
    },
    // 新增费用行
    addCommission(list) {
      const key = Date.now();
      list.push({ key: 'b' + key, programIds: [], programNames: [], commission: '' });
      this.$nextTick(() => {
        document.getElementById('keyb' + key).scrollIntoView();
      });
    },
    del(list, i, type) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: type == 2 ? '请确认是否删除？' : '请确认删除该费用项全部信息？'
        })
        .then(() => {
          if (list[i].id && type == 1) {
            this.$http({
              url: '/buz/upcommission/delGradientCommission',
              type: 'GET',
              data: {
                gradientCommissionId: list[i].id
              }
            }).then(res => {
              this.$emit('reload');
              list.splice(i, 1);
            });
          } else {
            list.splice(i, 1);
          }
        });
    },
    // 禁用选项
    disabledOpt(list, id) {
      let programIds = [];
      list.forEach(item => {
        programIds = programIds.concat(item.programIds);
      });
      return programIds.includes(id);
    },
    cancel() {
      this.visible = false;
    },
    submit() {
      const formArr = this.$refs.form.map(item => item.validate());
      Promise.all(formArr).then(formList => {
        let hasErr = formList.includes(false);
        const arr = JSON.parse(JSON.stringify(this.list));
        arr.forEach((item, i) => {
          item.gradientItemList.forEach((item2, ii) => {
            if (!item2.conditionStart) {
              this.$set(this.list[i].gradientItemList[ii], 'startError', true);
              hasErr = true;
            } else {
              this.$set(this.list[i].gradientItemList[ii], 'startError', false);
            }
            if (!item2.conditionEnd) {
              this.$set(this.list[i].gradientItemList[ii], 'endError', true);
              hasErr = true;
            } else {
              this.$set(this.list[i].gradientItemList[ii], 'endError', false);
            }
            if (item2.conditionStart && item2.conditionEnd) {
              if (item2.conditionStart * 1 >= item2.conditionEnd * 1) {
                this.$set(this.list[i].gradientItemList[ii], 'startError', true);
                this.$set(this.list[i].gradientItemList[ii], 'endError', true);
                hasErr = true;
              } else {
                this.$set(this.list[i].gradientItemList[ii], 'startError', false);
                this.$set(this.list[i].gradientItemList[ii], 'endError', false);
              }
            }
            let list = [];
            item2.programCommissionList.forEach((item3, iii) => {
              if (item3.programIds.length == 0) {
                this.$set(this.list[i].gradientItemList[ii].programCommissionList[iii], 'error', true);
                hasErr = true;
              } else {
                this.$set(this.list[i].gradientItemList[ii].programCommissionList[iii], 'error', false);
              }
              if (item3.commission === '') {
                this.$set(this.list[i].gradientItemList[ii].programCommissionList[iii], 'commissionError', true);
                hasErr = true;
              } else {
                this.$set(this.list[i].gradientItemList[ii].programCommissionList[iii], 'commissionError', false);
              }
              const list2 = item3.programIds.map(id => ({
                programId: id,
                commission: item3.commission
              }));
              list = list.concat(list2);
            });
            item2.programCommissionList = list;
          });
        });
        if (hasErr) {
          this.$notice.msg('请完善信息');
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          url: '/buz/upcommission/configGradientCommissionList',
          type: 'POST',
          data: arr
        })
          .then(res => {
            this.$notice.msg('操作成功');
            this.$emit('reload');
            this.visible = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.tools-box {
  padding-top: 15px;
}
.table {
  min-width: 1120px;
  margin-right: 10px;
  margin-bottom: 30px;
  .td1 {
    flex: 300px;
  }
  .td2 {
    flex: 250px;
  }
  .td3 {
    flex: 100px;
  }
  .td23 {
    flex: 350px;
  }
}
</style>  